/**
 */
class MemoryCache {
    constructor() {
        this.cache = {};
    }
    /**
     * @param {string} key
     * @return {*}
     */
    get(key) {
        return this.cache[key];
    }
    /**
     * @param {string} key
     * @return {string | null}
     */
    has(key) {
        return key in this.cache;
    }
    /**
     * @param {string} key
     * @param {*} value
     * @return {Promise<undefined>}
     */
    async set(key, value) {
        return new Promise((resolve) => {
            this.cache[key] = value;
            resolve();
        });
    }
}
export default MemoryCache;
